import { BreadcrumbLink as CBreadcrumbLink } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const BreadcrumbLink = (props) => {
  return (
    <CBreadcrumbLink
      as={Link}
      pointerEvents={props.isCurrentPage ? "none" : "unset"}
      color={props.isCurrentPage ? "#06c344" : "#718096"}
      borderRadius="2px"
      _hover={{
        shadow: "0 0 0 3px #06C3448f",
      }}
      _focus={{
        shadow: "0 0 0 3px #06C3448f",
      }}
      {...props}
    >
      {props.children}
    </CBreadcrumbLink>
  );
};

export default BreadcrumbLink;
